import { useState, useEffect } from 'react';
import { basic, validationMessages, wholeNumber } from '../../../config/validations';
import { useForm } from "react-hook-form";
import { Grid, TextField, Typography } from '@material-ui/core';
import TransactionNodes from './TransactionNodes';
import { handleSnackBar, setSelectedTransactionId, setFocusElement, toggleRightDrawer, toggleBottomDrawer, setReRender } from '../../../store/global/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { invokePostService } from "../../../store/global/actions";
import { generateMongoId, validateNonAsciiChars } from '../../../utils/commonUtils';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import CreateCancel from '../../atoms/buttons/CreateCancel';
import { getBottomDrawerStatus, getRightDrawerStatus } from '../../../store/global/selectors';


const shortUUiD = require("short-uuid");

export default function CreateTransaction({ onClose, forView, transactionDetails, setTransactionDetails , fetchTrasactionName}) {

    console.log("Nametyetytye--------", fetchTrasactionName,forView)
    const dispatch = useDispatch();
    const history = useHistory();
    const { register, handleSubmit, formState: { errors }, setError, setValue } = useForm();
    const [transaction, setTransaction] = useState({});
    const bottomDrawerStatus = useSelector(getBottomDrawerStatus);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    const [nodesLoading, setNodesLoading] = useState('false')
    const [isCreating, setIsCreating] = useState(false);
    const [selectedIcons, setSelectedIcons] = useState([]);

    const [showAdvanced, setShowAdvanced] = useState(false);

    let [, , slug, id, tag] = history.location.pathname.split("/");

    const messages = {
        ...validationMessages,
        validate: 'Duplicate transaction name given'
    }

    useEffect(() => {
    }, [selectedIcons]);    

    // useEffect(() => {
    //     if(forView){
    //         setValue("name", fetchTrasactionName);
    //     }
    // }, [forView]);
    
    useEffect(() => {
        if (forView && fetchTrasactionName) {
            setValue('name', fetchTrasactionName);
    
            setTransaction(prev => ({
                ...prev,
                name: fetchTrasactionName
            }));
        }
    }, [fetchTrasactionName, forView]);


    const handleTransactionChange = (e) => {
        const { name, value } = e.target;
        setTransaction(prev => ({ ...prev, [name]: value }));
    };

    const onCreate = async () => {
        console.log("On Create Actual Transaction")

        setIsCreating(true);
        if (selectedIcons.length === 0) {
            setIsCreating(false)
            dispatch(handleSnackBar({ open: true, message: 'Must select nodes to create transaction', severity: 'error' }));
            return;
        }

        // To close the rightdrawer if it in opened state
        if(rightDrawerStatus){
            dispatch(toggleRightDrawer());
        }

        if (selectedIcons.length === 1) {
            setIsCreating(false)
            dispatch(handleSnackBar({ open: true, message: 'Minimum two nodes must be selected to create transaction', severity: 'error' }));
            return;
        }

        const { name, description, spec, version, section, timeout, onerror } = transaction;
        const newTransaction = {
            id: shortUUiD.generate(),
            type: 7,
            name,
            description,
            invokedTransactions: [],
            nestedTransactions: [],
            templateTransactions: [],
            events: [],
            clusterlets: selectedIcons.map((node, key) => ({ id: node._id, order: key, category: node.category !== undefined ? node.category : 'userdefined' }))
        }
        console.log("NewTRansaction-------", newTransaction)
        if(section !== undefined && section !== ""){
            newTransaction.section = section;
        }
        if(spec !== undefined && spec !== ""){
            newTransaction.spec = spec;
        }
        if(version !== undefined && version !== ""){
            newTransaction.version = version;
        }
        if(timeout !== undefined && timeout !== ""){
            newTransaction.timeout = timeout;
        }
        if(onerror !== undefined && onerror !== ""){
            newTransaction.onerror = onerror
        }


        dispatch(invokePostService('createTransaction', { transaction: newTransaction }, []))
            .then(savedData => {
                if (savedData?.status) {
                    if(bottomDrawerStatus) dispatch(toggleBottomDrawer());
                    if(rightDrawerStatus) dispatch(toggleRightDrawer());
                    dispatch(handleSnackBar({ open: true, message: `Transaction ${newTransaction.name} created`, severity: "success" }));
                    dispatch(setSelectedTransactionId(newTransaction.id));
                    history.push(`/blueprint/${slug}/${id}/transaction/${savedData.data._id}`);
                    dispatch(setReRender());
                    onClose();
                }else if (savedData?.status === false && savedData.errors !== undefined && savedData.errors.length > 0) {

                    if (savedData?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        savedData?.errors?.forEach(error => {
                            setError(error.name, { message: error.message });
                        });
                    }
                    //dispatch(handleSnackBar({ open: true, message: savedData.errors[0]?.message ? savedData.errors[0]?.message : 'Something went wrong', severity: "error" }));
                }else {
                    if(bottomDrawerStatus) dispatch(toggleBottomDrawer());

                    if(!bottomDrawerStatus) dispatch(toggleRightDrawer());
                    dispatch(setFocusElement({}));
                    dispatch(handleSnackBar({ open: true, message: savedData.message, severity: "error" }));

                }
                setIsCreating(false)

            })
            .catch(error => console.error(error));
    }

    const onCreateTransactionForView = async () => {
        console.log("On Creating View transaction")
        if (selectedIcons.length < 2) {
            dispatch(handleSnackBar({ open: true, message: 'You must select at least one more node in addition to the Controller.', severity: 'error'  }));
            return; // Prevent execution
        }
        setIsCreating(true);
        let transactionObj = {
            _id: generateMongoId(),
            type: 7,
            name: transaction.name,
            description : "",
            invokedTransactions: [],
            nestedTransactions: [],
            templateTransactions: [],
            events: [],
            clusterlets: selectedIcons.map((node, key) => ({ id: node._id, order: key, ...node }))
        }
        setTransactionDetails({...transactionObj });
        setIsCreating(false)
        onClose();
    }

    return (
        <Grid container direction={"row"} spacing={3}>

            <Grid item xs={12}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    variant="outlined"
                    placeholder={""}
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                    onChange={handleTransactionChange}
                    // defaultValue={(forView && fetchTrasactionName) ? fetchTrasactionName : ""}
                />
            </Grid>
            {!forView && <Grid item xs={12}>
                <TextField
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    variant="outlined"
                    name="description"
                    error={errors.description}
                    helperText={errors.description ? errors?.description?.message : ''}
                    inputRef={register({ required: false, validate: validateNonAsciiChars })}
                    onChange={handleTransactionChange}
                />
            </Grid>}

            {<TransactionNodes setNodesLoading={setNodesLoading} selectedIcons={selectedIcons}  setSelectedIcons={setSelectedIcons} forView={forView}/>}

            {/* --- Add this block below TransactionNodes --- */}
            {selectedIcons.length > 0 && (
                <Grid item xs={12} style={{ marginTop: '10px', marginBottom: '10px' }}>
                    <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                        Transaction Flow:
                    </Typography>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        background: '#f5f5f5',
                        padding: '10px',
                        borderRadius: '4px'
                    }}>
                        {selectedIcons.map((node, index) => (
                            <div key={node._id} style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="body2" style={{ fontWeight: 600 }}>
                                    {node.name}
                                </Typography>
                                {index < selectedIcons.length - 1 && (
                                    <Typography variant="body2" style={{ margin: '0 8px', color: '#888' }}>
                                        →
                                    </Typography>
                                )}
                            </div>
                        ))}
                    </div>
                </Grid>
            )}

            {!forView && <Grid item xs={12}>
                <Typography
                    variant="body2"
                    color="primary"
                    style={{ cursor: 'pointer', textDecoration: 'underline', display: 'flex', alignItems: 'center' }}
                    onClick={() => setShowAdvanced(!showAdvanced)}
                >
                    {showAdvanced ? 'Hide Advanced Options' : 'Show Advanced Options'}
                    {showAdvanced ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </Typography>
            </Grid>}


            {!forView &&  showAdvanced && <>
                <Grid item xs={6}>
                    <TextField
                        name="section"
                        fullWidth
                        type={"text"}
                        label={"Section"}
                        variant="outlined"
                        placeholder={""}
                        inputRef={register({ required: false })}
                        onChange={handleTransactionChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        name="spec"
                        fullWidth
                        type={"text"}
                        label={"Specification"}
                        variant="outlined"
                        placeholder={""}
                        inputRef={register({ required: false })}
                        onChange={handleTransactionChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        name="version"
                        fullWidth
                        type={"text"}
                        label={"Version"}
                        variant="outlined"
                        placeholder={""}
                        inputRef={register({ required: false })}
                        onChange={handleTransactionChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name="timeout"
                        fullWidth
                        type={"text"}
                        label={"Timeout"}
                        variant="outlined"
                        placeholder={"In milliseconds"}
                        error={errors?.timeout ? true : false}
                        inputRef={register({ ...wholeNumber })}
                        helperText={errors?.timeout && errors?.timeout?.message ? errors.timeout.message : ''}
                        onChange={handleTransactionChange}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                        name="onerror"
                        fullWidth
                        type={"text"}
                        label={"OnError"}
                        variant="outlined"
                        placeholder={"Specify the function name"}
                        error={errors?.onerror ? true : false}
                        inputRef={register({})}
                        onChange={handleTransactionChange}
                    // helperText={errors?.timeout && errors?.timeout?.message ? errors.timeout.message : ''}
                    />
                </Grid>
            </>}
           
            {<Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                {/* {stage == 'basic' && <NextCancel onNext={handleSubmit(onNext)} onCancel={onClose} disableNext={isCreating} content={isCreating ? 'Loading..' : 'Next'} />} */}
                {<CreateCancel onCreate={ forView ?  handleSubmit(onCreateTransactionForView) : handleSubmit(onCreate) } onCancel={onClose} createDisable={isCreating || nodesLoading} content={nodesLoading? 'Loading..' : (isCreating? 'Creating..' : 'Create')} />}
            </Grid>}


        </Grid>
    )
}

